import React from 'react';

import { TradeSolicitacaoPecaMensagemFormComp, TradeSolicitacaoPecasListComp, TradeSolicitacoesPecaFormComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function TradeSolicitacoesPecasList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['TRADE_SOLICITACAO_PECA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <TradeSolicitacaoPecasListComp />
        </ListagemProvider>
    );
}

export function TradeSolicitacoesPecasForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['TRADE_SOLICITACAO_PECA_SOLICITAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <TradeSolicitacoesPecaFormComp />
        </FormProvider>
    );
}
export function TradeSolicitacaoPecaMensagemForm() {
    return (
        <FormProvider>
            <TradeSolicitacaoPecaMensagemFormComp />
        </FormProvider>
    );
}
